import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { getFormValues } from 'redux-form';

import { FORM_NAME, RECORDER, RECORDER_STATE, RECORDER_STATES, STREAM } from '../fields';
import { RecorderTimer } from '../recorder-timer';
import { MicrophoneVolumeLevel } from '../microphone-volume-level';
import { createAndStartRecorder, useCleanUpRecorder, resumeRecording } from '../recording-step';
import { StartCounter } from './start-counter';

export const RecordingBody = () => {
  const { t } = useTranslation();

  const {
    [RECORDER]: recorder,
    [RECORDER_STATE]: recorderState,
    [STREAM]: stream,
  } = useSelector(getFormValues(FORM_NAME));

  const dispatch = useDispatch();

  useCleanUpRecorder();

  const bodyMsg =
    recorderState === RECORDER_STATES.PAUSED || recorderState === RECORDER_STATES.WILL_RESUME
      ? t('recording_paused_message')
      : t('recording_message');

  const onRecordingExpired = () => createAndStartRecorder(stream, dispatch);
  const onResumeRecordingExpired = () => resumeRecording(dispatch, recorder);

  const recorderStarted = !!recorderState;
  const recorderWillResume = recorderState === RECORDER_STATES.WILL_RESUME;

  return (
    <>
      <div>{bodyMsg}</div>
      <div className="ct-screen-record-counter-box">
        {recorderStarted ? (
          <>
            <RecorderTimer style={recorderWillResume ? { display: 'none' } : null} />
            {recorderWillResume && <StartCounter countFrom={3} expired={onResumeRecordingExpired} />}
          </>
        ) : (
          <StartCounter countFrom={3} expired={onRecordingExpired} />
        )}
      </div>
      <MicrophoneVolumeLevel />
    </>
  );
};
